<template>
  <mobile :lang="'ru'" v-if="deviceWidth < 768" class="md:hidden mobile" style="color: white; overflow: hidden"/>
  <tablet v-else-if="deviceWidth < 1024" class="hidden md:block xl:hidden tablet"/>
  <desktop v-else class="hidden xl:block desktop"/>

</template>

<script>
import mobile from "./components/mobile.vue"
import desktop from "./components/desktop";
import tablet from "@/components/tablet";

import './assets/fonts.css'

export default {
  name: "App",
  components:{
    desktop,
    mobile,
    tablet
  },
  data(){
    return{
      deviceWidth: null
    }
  },
  created() {
    this.deviceWidth = window.innerWidth
    window.addEventListener('resize',()=>{
      this.deviceWidth = window.innerWidth
    })
  }
};
</script>

<style lang="scss">

</style>
